import messages from './member.json' with { type: 'json' };

export const memberSv: Readonly<typeof messages> = messages;
